import apiClient from './client'
import type { SolicitudCompra, SolicitudCompraInput, PaginatedResponse } from '@/types/gia'

export interface ComprasFilters {
  page?: number
  page_size?: number
  estado?: string
  centro?: number
}

export const comprasApi = {
  list: async (filters: ComprasFilters = {}): Promise<PaginatedResponse<SolicitudCompra>> => {
    const response = await apiClient.get<PaginatedResponse<SolicitudCompra>>('/compras/', { params: filters })
    return response.data
  },

  get: async (id: number): Promise<SolicitudCompra> => {
    const response = await apiClient.get<SolicitudCompra>(`/compras/${id}/`)
    return response.data
  },

  create: async (data: SolicitudCompraInput): Promise<SolicitudCompra> => {
    const response = await apiClient.post<SolicitudCompra>('/compras/', data)
    return response.data
  },

  update: async (id: number, data: Partial<SolicitudCompraInput>): Promise<SolicitudCompra> => {
    const response = await apiClient.patch<SolicitudCompra>(`/compras/${id}/`, data)
    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/compras/${id}/`)
  },

  aprobar: async (id: number): Promise<SolicitudCompra> => {
    const response = await apiClient.post<SolicitudCompra>(`/compras/${id}/aprobar/`)
    return response.data
  },

  rechazar: async (id: number, motivo_rechazo: string): Promise<SolicitudCompra> => {
    const response = await apiClient.post<SolicitudCompra>(`/compras/${id}/rechazar/`, { motivo_rechazo })
    return response.data
  },

  actualizarEstado: async (
    id: number,
    estado: string,
    extra?: { precio_real?: number | null; fecha_compra?: string; numero_pedido?: string }
  ): Promise<SolicitudCompra> => {
    const response = await apiClient.post<SolicitudCompra>(`/compras/${id}/actualizar_estado/`, {
      estado,
      ...extra,
    })
    return response.data
  },

  pendientesCount: async (): Promise<number> => {
    const response = await apiClient.get<{ count: number }>('/compras/pendientes_count/')
    return response.data.count
  },
}
